import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    smsContactsListItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0px 4px 0px 0px',
        boxShadow: 'inset 3px 0 0 transparent',
        transition: 'background-color 0.15s ease',
        '&:hover': {
            background: theme.palette.action.hover,
            cursor: 'pointer',
        },
    },
    // The open conversation: a light brand tint with an accent on the left.
    smsContactsListItemSelected: {
        background: 'rgba(77, 171, 245, 0.12)',
        boxShadow: `inset 3px 0 0 ${theme.palette.primary.light}`,
        '&:hover': {
            background: 'rgba(77, 171, 245, 0.16)',
        },
    },
    button: {
        backgroundColor: 'transparent',
        flex: 1,
        minWidth: 0,
        justifyContent: 'flex-start',
        textTransform: 'none',
        padding: '10px 8px 10px 12px',
        borderRadius: 0,
    },
    avatar: {
        marginRight: 12,
        flexShrink: 0,
    },
    smsContactsInfo: {
        flex: 1,
        minWidth: 0,
    },
    contactNameDate: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 8,
    },
    smsContactsTitle: {
        fontSize: 14.5,
        fontWeight: 500,
        lineHeight: 1.4,
        color: theme.palette.text.primary,
        margin: 0,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: 0,
    },
    smsContactsDate: {
        fontSize: 11.5,
        lineHeight: 1.4,
        color: theme.palette.text.secondary,
        margin: 0,
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    previewRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 8,
        marginTop: 2,
    },
    preview: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        margin: 0,
        textAlign: 'left',
        textTransform: 'none',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        lineHeight: 1.4,
        minWidth: 0,
    },
    previewYou: {
        color: theme.palette.text.disabled,
    },
    unreadTitle: {
        fontWeight: 600,
    },
    unreadPreview: {
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    unreadDate: {
        color: theme.palette.primary.light,
        fontWeight: 600,
    },
    badges: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexShrink: 0,
    },
    notDeliveredIcon: {
        width: 18,
        height: 18,
        color: theme.palette.secondary.main,
    },
    unreadMessages: {
        minWidth: 20,
        height: 20,
        padding: '0 6px',
        borderRadius: 10,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 600,
        color: '#fff',
        backgroundColor: theme.palette.primary.light,
    },
    draftLabel: {
        fontSize: 13,
        color: theme.palette.text.disabled,
    },
    discardNewMessage: {
        color: theme.palette.text.secondary,
        marginRight: 4,
        '&:hover': {
            color: theme.palette.secondary.main,
        },
    },
}));

export { useStyles }
